var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5L7.6 0l39.9 39.9L87.4 0 95 7.5 47.5 55z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NSA1NSI+PHBhdGggZD0iTTAgNy41TDcuNiAwbDM5LjkgMzkuOUw4Ny40IDAgOTUgNy41IDQ3LjUgNTV6Ii8+PC9zdmc+";
export { SvgArrowDown as ReactComponent };